export const ISSUELOG_SEVERITIES = [
    [0, 'Low'],
    [1, 'Medium'],
    [2, 'High'],
    [3, 'Critical'],
]
export const ISSUELOG_SEVERITIES_MAP = Object.fromEntries(ISSUELOG_SEVERITIES)

export const ISSUELOG_PRIORITIES = [
    [0, 'Low'],
    [1, 'Medium'],
    [2, 'High'],
    [3, 'Urgent'],
]
export const ISSUELOG_STATUSES = [
    [0, 'Open'],
    [1, 'Resolved'],
    [2, 'On hold'],
    [3, 'Ongoing'],
    [4, 'Evaluation'],
]
